// Settings.jsx
import React from 'react';
import { Switch } from '@headlessui/react';
import { useOutletContext } from 'react-router-dom';

const Settings = () => {
  const {
    isOrderingEnabled,
    orderStatusLoading,
    updateOrderStatus,
    summerTimingEnabled,
    updateSummerTiming,
  } = useOutletContext();

  if (orderStatusLoading) {
    return (
      <div className="bg-white shadow-lg rounded-2xl p-4 sm:p-6 text-candy-text border border-candy-border">
        <h1 className="text-xl sm:text-2xl font-bold mb-6 flex items-center gap-2">
          ⚙️ Settings
        </h1>
        <p>Loading settings…</p>
      </div>
    );
  }

  return (
    <div className="bg-white shadow-lg rounded-2xl p-4 sm:p-6 text-candy-text border border-candy-border space-y-8">
      <h1 className="text-xl sm:text-2xl font-bold flex items-center gap-2">
        ⚙️ Settings
      </h1>

      <div className="space-y-3">
        <div className="flex items-center gap-4 sm:gap-2 justify-between sm:justify-start">
          <span className="font-medium text-sm sm:text-base">
            {isOrderingEnabled ? '✅ Accepting Orders' : '❌ Not Accepting Orders'}
          </span>

          <Switch
            checked={isOrderingEnabled}
            onChange={updateOrderStatus}
            className={`${
              isOrderingEnabled ? 'bg-green-500' : 'bg-gray-300'
            } relative inline-flex h-6 w-11 items-center rounded-full transition-colors`}
          >
            <span
              className={`${
                isOrderingEnabled ? 'translate-x-6' : 'translate-x-1'
              } inline-block h-4 w-4 transform rounded-full bg-white transition-transform`}
            />
          </Switch>
        </div>
      </div>

      <div className="space-y-3 border-t border-candy-border pt-6">
        <div className="flex items-center gap-4 sm:gap-2 justify-between sm:justify-start">
          <div>
            <span className="font-medium text-sm sm:text-base block">
              {summerTimingEnabled ? '☀️ Summer Timing On' : 'Summer Timing Off'}
            </span>
            <p className="text-xs sm:text-sm text-gray-600 mt-1 max-w-xl leading-snug">
              Closed Sundays &amp; Mondays. Tuesday &amp; Wednesday pickups end at 4:00 PM.
              Weekend / late-Friday orders start Tuesday at 12:00 PM; Monday orders start Tuesday at 3:00 PM.
            </p>
          </div>

          <Switch
            checked={summerTimingEnabled}
            onChange={updateSummerTiming}
            className={`${
              summerTimingEnabled ? 'bg-amber-500' : 'bg-gray-300'
            } relative inline-flex h-6 w-11 shrink-0 items-center rounded-full transition-colors`}
          >
            <span
              className={`${
                summerTimingEnabled ? 'translate-x-6' : 'translate-x-1'
              } inline-block h-4 w-4 transform rounded-full bg-white transition-transform`}
            />
          </Switch>
        </div>
      </div>
    </div>
  );
};

export default Settings;
